import {Injectable} from '@angular/core';
import {BaseRequestOptions, Headers, RequestOptions, RequestOptionsArgs} from '@angular/http';

@Injectable()
export class CoreRequestOptions extends BaseRequestOptions {
    merge(options?:RequestOptionsArgs):RequestOptions {
        options.headers = new Headers();

        // add authorization token
        if (localStorage.getItem('token')) {
            options.headers.set('Authorization', localStorage.getItem('token'));
        }

        return super.merge(options);
    }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/core/core.request.options.ts